export default __webpack_public_path__ + "96dcc5937300a2af951b26b538ad6116.svg";